module.exports = __webpack_public_path__ + "img/store.fbd240c3.svg";